<template>
  <div class="klinik-instance klinik collapsed" :data-klinik="klinik.id">

    <div class="klinik-header" @click="klinikToggle(klinik.id)">
      <h3>{{ klinik.titel }}</h3>
      <button class="toggle-button">
        <svg viewBox="0 0 800 800"
             class="fill-red" width="36"
        >
          <polygon points="225,0 625,400 225,800 175,750 525,400 175,50"></polygon>
        </svg>
      </button>
    </div>

    <div class="subkliniken" v-if="klinik.kliniken && klinik.kliniken.length">
      <klinik-instance
          v-for="subklinik in klinik.kliniken"
          :key="subklinik.id"
          :klinik="subklinik"
      />
    </div>

    <div class="details">

      <div class="klinik-emails" v-if="klinik.emails?.length">
        <div v-for="email in klinik.emails" :key="email.adresse">
          <span>E-Mail{{ email.titel.length ? ' '+email.titel : ''}}: <a :href="'mailto:'+email.adresse">{{ email.adresse }}</a></span>
        </div>
      </div>

      <div class="abteilungen row" v-if="klinik.abteilungen?.length">
        <abteilung-instance
            v-for="abteilung in klinik.abteilungen"
            :key="abteilung.id"
            :abteilung="abteilung"
            :cssClass="klinik.abteilungen.length > 1 ? 'col-lg-6' : null"
        />
      </div>

      <div class="klinik-footer" v-if="klinik.footerFields?.length">
        <div v-for="field in klinik.footerFields" :key="field">
          <span v-html="field"></span>
        </div>
      </div>

    </div>

  </div>
</template>
<script>
import AbteilungInstance from "@/components/AbteilungInstance.vue";

export default {
  name: "KlinikInstance",
  components: {AbteilungInstance},
  props: ["klinik"],
  methods: {
    klinikToggle(klinik) {
      document.querySelector("[data-klinik='"+klinik+"']")?.classList.toggle('collapsed');
    },
  }
}
</script>
